import { useQuery } from '@tanstack/react-query'
import { referralsRepository } from '../repositories/referrals.repository'

const MY_REFERRALS_KEY = 'my-referrals'
const REFERRAL_SUMMARY_KEY = 'referral-summary'

export const useReferrals = () => {
  // Get hierarchical referrals data
  const {
    data: myReferrals,
    isLoading: referralsLoading,
    error: referralsError,
    refetch: refetchReferrals
  } = useQuery({
    queryKey: [MY_REFERRALS_KEY],
    queryFn: referralsRepository.getMyReferrals
  })

  // Get referral summary
  const {
    data: referralSummary,
    isLoading: summaryLoading,
    error: summaryError,
    refetch: refetchSummary
  } = useQuery({
    queryKey: [REFERRAL_SUMMARY_KEY],
    queryFn: referralsRepository.getSummary
  })

  const dataIsLoading = referralsLoading || summaryLoading
  const dataError = referralsError || summaryError

  const refetch = () => {
    refetchReferrals()
    refetchSummary()
  }

  return {
    // Data
    myReferrals: myReferrals || [],
    referralSummary,
    
    // Loading and error states
    dataIsLoading,
    dataError,
    
    // Actions
    refetch
  }
}